import React,{useEffect} from 'react';
import {Carousel, Col, Container, Row} from 'react-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';
import {IoIosArrowDown} from 'react-icons/io';



import Aos from "aos";
import "aos/dist/aos.css";

import './Thanks.css';


function ThanksPage() {
    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);


    return (
        <>
        
            
            <div className='CarouselWrapperP12'>
                {/* <img className = "CarouselPhotoP"
                    src = {Rue}
                    alt = "First slide" /> */}
                    <div className='AmenitiesHeaderWrapperP'>
                        <h1 className='AmenitiesH1'>Thank you!</h1>
                        <h2 >We will respond as soon as possible!</h2>
                        <Link to='#amenities'>
                            <IoIosArrowDown  className='ArrowDownP'  />
                        </Link>
                    </div>
                    
            </div>


            <Container id='amenities' fluid className='bodyBackgroundA'>
                <div className='AmenitiesHeaderWrapper'>
                    <h1 className='AmenitiesH1'></h1>
                </div>
                <div className='ContentsWrapper'>
                    <div>
                        {/* <p style={{fontSize:'20px'}}>
                        We aim for your stay with us to provide you with every luxury 
                        and comfort you desire and deserve. Numerous facilities and 
                        services cater to meet all your needs and demands for an idyllic 
                        stay. Our friendly and expert staff specializes in customizing our 
                        multitude of services to suit your exact requirements. Please feel 
                        free to contact us in advance to inform us of your needs or reach out 
                        to our reception at any time while staying with us.
                        </p> */}
                    </div>
                    
                
                    

                </div>
            </Container>
        
        </>
    )
}

export default ThanksPage